import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const golfIOs = {
    name: 'Golf iOS App',
    slug: 'golf-ios',
    description: 'Startup project that helps to organize the real golf playing game between players in better order. Gather statistics about players. Big Data real time processing. iPhone/iPad/Web/IoT interfaces.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/golf-ios/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by fullvector / Freepik'
        }
    },
    prominentColor: 'rgb(91,191,240)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/golf-ios/ipad.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Pressfoto / Freepik'
                    }
                }, {
                    url: `${PUBLIC_URL}/portfolio/golf-ios/iphone-stat.png`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Dimas_Sugih / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/golf-ios/iphone-bar-chart.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by fullvector / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/golf-ios/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by fullvector / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'iOS developer for iPhone and iPad applications',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['Swift', 'Objective-C'],
        } as PieceUnorderedList,
    ],
};

export default golfIOs;


// WEBPACK FOOTER //
// ./src/store/portfolio/golf-ios.tsx